// See: https://stackoverflow.com/questions/41123631/how-to-get-the-version-from-the-package-json-in-typescript

import { APP_VERSION, PRODUCT_VERSION } from "./version.generated";

export const AppVersion = APP_VERSION;
export const ProductVersion = PRODUCT_VERSION;
export const ApiVersion = "v1.0.0";
